import { useState } from "react";
// @mui
import {
  Button,
  CircularProgress,
  Grid,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Alert,
} from "@mui/material";
import { post } from "src/utils/networkUtils";

// ----------------------------------------------------------------------

const defaultConnectionData = {
  user: "",
  password: "",
  name: "",
  server: "",
  targetTenantId: "",
};
export default function ConnectionMigrateDialog(props) {
  const {
    title,
    description,
    apiEndpoint,
    entityName,
    additionalParams = {}
  } = props;

  const [connectionData, setConnectionData] = useState(defaultConnectionData);
  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [migrationResult, setMigrationResult] = useState(null);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setConnectionData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = async () => {
    setLoading(true);
    try {
      const requestData = {
        ...connectionData,
        ...additionalParams
      };
      const response = await post(apiEndpoint, requestData);
      setLoading(false);
      setMigrationResult(response.totalUpdated);
      setShowResult(true);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };
  const onCancel = () => {
    props.onClose();
  };

  const handleResultClose = () => {
    setShowResult(false);
    setMigrationResult(null);
    props.onClose();
  };

  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContentText sx={{ px: 3 }}>
          {description}
        </DialogContentText>
        <DialogContent>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container>
              <Grid item xs={6} sx={{ m: 0, p: 1 }}>
                <TextField
                  id="user"
                  label="DB Username"
                  fullWidth
                  value={connectionData.user}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6} sx={{ m: 0, p: 1 }}>
                <TextField
                  id="password"
                  label="DB Password"
                  fullWidth
                  value={connectionData.password}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={6} sx={{ m: 0, p: 1 }}>
                <TextField
                  id="name"
                  label="DB Name"
                  fullWidth
                  value={connectionData.name}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={6} sx={{ m: 0, p: 1 }}>
                <TextField
                  id="server"
                  label="DB Server"
                  fullWidth
                  value={connectionData.server}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={6} sx={{ m: 0, p: 1 }}>
                <TextField
                  id="targetTenantId"
                  label="Target Tenant ID"
                  fullWidth
                  value={connectionData.targetTenantId}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
          <Button onClick={() => onSuccess()} autoFocus disabled={loading}>
            Migrate
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showResult}
        onClose={handleResultClose}
        aria-labelledby="result-dialog-title"
      >
        <DialogTitle id="result-dialog-title">Migration Complete</DialogTitle>
        <DialogContent>
          <Alert severity="success" sx={{ mt: 1 }}>
            Successfully migrated {migrationResult} {entityName}.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResultClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
